// @flow
import React, { Component } from 'react';
import Modal from '@localytics/loc-components/lib/Modal';
import Button from '@localytics/loc-components/lib/Button';
import 'whatwg-fetch';
import { connect } from 'react-redux';
import { Route, Redirect, withRouter, Switch } from 'react-router-dom';
import { GENERIC_ERROR_MESSAGE } from './constants/ApiTypes';
import { AUTH_REFRESH_INTERVAL } from './constants/AuthTypes';
import type { ErrorResponse } from './constants/ApiTypes';
import * as ApiActions from './actions/api';
import * as RailsApiActions from './actions/rails-api';
import * as AuthActions from './actions/auth';
import ChooseOrchPage from './ChooseOrchPage';
import Flowbuilder from './components/Flowbuilder';
import Wizard from './Wizard';
import NotFound from './NotFound';
import SvgIcons from './components/SvgIcons';
import { getQueryParams, ALL_PATH } from './util/RouterUtils';
import './Page.scss';

type Props = {
  location: Object,
  getOrchestrations: Function,
  getEventMappings: Function,
  getAppGroups: Function,
  getApps: Function,
  hideErrors: Function,
  refreshCredentials: Function,
  orgId: number,
  pageErrors: {
    errorResponse: ErrorResponse,
    showErrors: boolean
  }
};

type State = {};

class Page extends Component<Props, State> {
  constructor(props: Props) {
    super(props);

    this.state = {};
  }

  componentWillMount() {
    this.maintainCredentials(() => this.loadData());
  }

  loadData() {
    const { orgId } = this.props;
    if (!orgId) {
      return;
    }
    // For now this is needed for initial page load to ChooseOrchPage
    // Thereafter, switching the page back to ChooseOrchPage will make the same request
    this.props.getOrchestrations(orgId);
    // Rails
    this.props.getEventMappings(orgId);
    this.props.getAppGroups(orgId);
    this.props.getApps(orgId);
  }

  maintainCredentials(authorizedCallback) {
    this.props.refreshCredentials(this.props.orgId, authorizedCallback);
    window.setTimeout(() => this.maintainCredentials(), AUTH_REFRESH_INTERVAL);
  }

  hideErrors() {
    this.props.hideErrors();
  }

  render() {
    const { orgId } = this.props;
    const { showErrors, errorResponse } = this.props.pageErrors;

    const PageBody =
      orgId === null ? (
        <NotFound orgId={orgId} />
      ) : (
        <Switch>
          <Redirect
            exact
            from="/"
            to={{
              pathname: ALL_PATH,
              search: this.props.location.search
            }}
          />
          <Route path={ALL_PATH} component={ChooseOrchPage} key={1} />
          <Route path="/new" component={Wizard} key={1} />
          <Route path="/show" component={Flowbuilder} key={1} />
          <Route render={() => <NotFound orgId={orgId} />} key={1} />
        </Switch>
      );

    return (
      <div className="Page__Container">
        <SvgIcons />
        <Modal
          className="ErrorModal"
          show={showErrors}
          onHide={() => this.hideErrors()}
        >
          <div className="ErrorModal__Content">
            <div>
              {errorResponse.message
                ? errorResponse.message
                : GENERIC_ERROR_MESSAGE}
            </div>
            <div className="ErrorModal__Content__Buttons">
              <Button
                type="primary"
                size="large"
                label="OK"
                onClick={() => this.hideErrors()}
              />
            </div>
          </div>
        </Modal>
        {PageBody}
      </div>
    );
  }
}

const mapStateToProps = (state, ownProps) => {
  const { orgId, orchestrationId, versionId } = getQueryParams(
    ownProps.location
  );
  return {
    api: state.api,
    railsApi: state.railsApi,
    orgId,
    orchestrationId,
    versionId,
    pageErrors: {
      showErrors: state.railsApi.showErrors || state.api.showErrors,
      errorResponse: {
        ...state.api.errorResponse,
        ...state.railsApi.errorResponse
      }
    }
  };
};

const mapDispatchToProps = {
  ...ApiActions,
  ...RailsApiActions,
  ...AuthActions
};

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(Page));



// WEBPACK FOOTER //
// ./src/Page.jsx